<template>
  <div class="submit-suggestion">
    <div class="title flex-space-between">
      <div class="txt">处理意见</div>
      <div class="more" @click="toggleVisible">
        常用语 <a-icon type="message"></a-icon>
      </div>
    </div>
    <div class="textarea">
      <a-textarea placeholder="请输入处理意见" v-model="inputText"></a-textarea>
    </div>
    <a-drawer
      title="选择常用语"
      placement="bottom"
      :closable="false"
      :visible="visible"
      @close="toggleVisible"
      height="300px"
    >
      <div class="common-words">
        <div class="word" @click="wordSelected('同意')">同意</div>
        <div class="word" @click="wordSelected('不同意')">不同意</div>
        <div class="word" @click="wordSelected('已阅')">已阅</div>
        <div class="word" @click="wordSelected('通过')">通过</div>
        <!-- <div class="word">
          <a-button block @click.native="addCommonWords">
            新增常用语<a-icon type="plus-circle"></a-icon>
          </a-button>
        </div> -->
      </div>
    </a-drawer>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      visible: false,
      inputText: ''
    }
  },
  methods: {
    toggleVisible() {
      this.visible = !this.visible
    },
    wordSelected(word) {
      this.inputText = this.inputText.concat(word)
      this.toggleVisible()
    },
    addCommonWords() {
      this.toggleVisible()
      this.$router.push('./addCommonSuggestions')
    },
    getValue() {
      return this.inputText
    }
  }
}
</script>
<style scoped lang="scss">
@import '../../style/var';
.submit-suggestion {
  margin-bottom: 7rem;
}
.title {
  border-left: 3px solid $--color-primary;
  margin: 15px 10px;
  padding-left: 10px;
  .txt {
    font-size: 15px;
    color: #333;
  }
  // padding: 7rem 10rem;
  // margin-top: 7rem;
}
.textarea {
  margin: 0 10px;
}
.common-words {
  height: 100%;
  display: flex;
  flex-direction: column;
  & .word {
    padding: 10px;
    border-bottom: 1px solid #f2f2f2;
    &:active {
      font-weight: bold;
      background-color: $--color-primary;
    }
    // &:last-child {
    //   color: aqua;
    //   text-align: center;
    //   border-bottom: none;
    // }
  }
}
</style>
